import { project, SCENE_VIEW, type Camera } from '../../engine/battlefield/projection';
import { tokenFoot, type Token } from '../../engine/battlefield/tokens';
import { edgeMark } from '../../engine/display/focus';
import styles from '../../styles/Display.module.css';

/**
 * The edge chevron (plan map-display, C): a target off the view - too far to
 * frame with the actor, or turned away from - is pointed at from the edge,
 * on the line from the middle of the view towards it. Nothing when it is on
 * screen, or when there is no target.
 */
export default function TargetChevron({ target, camera }: { target: Token | null | undefined; camera: Camera }) {
  if (!target) return null;
  const foot = project(tokenFoot(target), camera, SCENE_VIEW);
  const mark = edgeMark(foot, SCENE_VIEW);
  if (!mark) return null;
  return (
    <path
      data-testid="display-target-chevron"
      className={styles.edgeChevron}
      d="M 12 0 L -8 -9 L -3 0 L -8 9 Z"
      transform={`translate(${mark.x.toFixed(1)} ${mark.y.toFixed(1)}) rotate(${mark.angle.toFixed(1)})`}
    />
  );
}
